import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faEye } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Popup from "reactjs-popup";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import apiUrl from "../../apiUrlConstant";
import TopHeader from "../../layout/TopHeader";
import { ChartPopup } from "../../utils/utils";
import { fileUploadPath } from "../../utils/index";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
var ReactS3Uploader = require("react-s3-uploader");

var today = new Date(),
  date =
    today.getDate() + "/" + today.getMonth() + 1 + "/" + today.getFullYear();

class MoreInfoComponent extends React.Component {
  state = {
    terminationEffectiveDate: new Date(),
    effectiveDate: new Date(),
    redirect: false,
    changeLandlord: false,
    delete: false,
    additionalDetails: [],
    leaseId: this.props.leaseId,
    leaseCode: this.props.leaseCode,
    costCenter: this.props.costCenter,
    marque_status: this.props.marqueStatus,
    dispute_status: this.props.desputeStatus,
    initialValues: {
      landlordId: [],
    },
  };
  style = (feature) => {
    return {
      fillColor: "#ccc",
      weight: 1,
      opacity: 1,
      color: "#003970",
      dashArray: "2",
      fillOpacity: 0.5,
    };
  };
  constructor(props) {
    super(props);
    //this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  componentDidMount() {
    var date = new Date();
    var formatedDate = `${date.getFullYear() + 1
      }-${date.getMonth()}-${date.getDate()}`;
    this.setState({ terminationEffectiveDate: formatedDate }, () => {
      console.log(this.state.terminationEffectiveDate);
    });
    console.log(formatedDate);
  }



  hidePopup() {
    this.props.setShow(false);
  }


  redirectAfterSave = () => {
    this.setState({ delete: false });
  };

  render() {
    return (
      <div>
        <Formik
          initialValues={this.state}
          //enableReinitialize
          onSubmit={(values, actions) => {
            var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/lease-view/update-marque-status?leaseId=${this.state.leaseId}`,
      data: this.state,
    }).then(function (response) {
        console.log(response,"repsonse")
      if (response.data.success) {
        self.hidePopup();
        self.props.setpopupMessageContent("Details Stored successfully.");
        self.props.setpopupalertMessage(true);
      }})


          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            resetForm,
          }) => (
            <Form autoComplete="off" className="customTabs">
              <div className="unitFormContainer amend">
                <div className="container-fluid p-0">
                  <div className="row prospectAccordion">
                    <div className="col-lg-6 offset-lg-3">
                      <div className="tableContainer prospectTable mt-0">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Lease No
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.leaseCode}
                              </td>
                            </tr>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Cost Center
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.costCenter}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="inputContainer"></div>
                    </div>
                    <div className="col-lg-12">
                      <div className="tableContainer screens">
                        
                        <table className="table tableSimple tableSimpleWithNoFlex">
                          <thead>
                            <tr>
                              <th>Section</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Marque Store</td>
                              <td>
                              <Field
                                  type="checkbox"
                                  name={`marque_status`}
                                  checked={this.state.marque_status}
                                disabled={
                                    typeof this.state.marque_status != "undefined" &&
                                    this.state.marque_status.length === 1
                                    ? true
                                    : false
                                }
                                onClick={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ marque_status: 1 });
                                      } else {
                                        this.setState({ marque_status: 0 });
                                      }
                                }}
                                //   onChange={(e) => {
                                //       console.log
                                //     this.setState({ marque_status: e.target.value  });
                                //     handleChange(e);
                                //   }}
                                  className="sameAs"
                                />
                               
                              </td>
                            </tr>
                            <tr>
                              <td>
                              Dispute
                              </td>
                              <td>
                                <Field
                                  type="checkbox"
                                  name={`dispute_status`}
                                  checked={this.state.dispute_status}
                                disabled={
                                    typeof this.state.dispute_status != "undefined" &&
                                    this.state.dispute_status.length === 1
                                    ? true
                                    : false
                                }
                                onClick={(e) => {
                                    if (e.target.checked) {
                                        this.setState({ dispute_status: 1 });
                                      } else {
                                        this.setState({ dispute_status: 0 });
                                      }
                                }}
                                  className="sameAs"
                                />
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>
                      </div>
                    </div>

                    
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-center">
                        <button type="submit" className="update_button">Update</button>
                      </div>
                    
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>

        

        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              "Are you sure to delete this item??"
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectToTerminate}>
                  Yes
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  }
}

export default withRouter(MoreInfoComponent);
